import { useState } from "react";
import EstablishmentUnitCreate from "./EstablishmentUnitCreate";
import EstablishmentUnitEdit from "./EstablishmentUnitEdit";
import EstablishmentUnitView from "./EstablishmentUnitView";

const EstablishmentUnitIndex = ({
  index,
  isActive,
  mode,
  nextButtonFunction,
  toggleEdit,
  establishmentID,
  closeWizard,
  updateInterfaceData,
  interfaceData
}: EstablishmentUnitIndexProps) => {

  const [isEstablishmentUnitInit, setIsEstablishmentUnitInit] = useState(mode === "edit" ? true : false);
  
  return (
    <>
      {mode === "create" && isActive &&
        <EstablishmentUnitCreate
        nextButtonFunction={nextButtonFunction}
        setIsEstablishmentUnitInit={setIsEstablishmentUnitInit} 
        updateInterfaceData={updateInterfaceData}        />
      }

      {mode === "edit" && isActive && 
        <EstablishmentUnitEdit
        nextButtonFunction={nextButtonFunction}
        establishmentID={establishmentID}
        setIsEstablishmentUnitInit={setIsEstablishmentUnitInit}
        updateInterfaceData={updateInterfaceData} 
        interfaceData={interfaceData}        />
      } 

      {isEstablishmentUnitInit && !isActive &&
        <EstablishmentUnitView 
        toggleEdit={toggleEdit}
        userID={establishmentID}
        closeWizard={closeWizard} 
        interfaceData={interfaceData}        />
      }  
    </>
  )
}

export default EstablishmentUnitIndex;

type EstablishmentUnitIndexProps = {
  isActive: boolean;
  nextButtonFunction: () => void;
  index: number;
  toggleEdit: () => void;
  mode: "create" | "edit";
  establishmentID?: number;
  closeWizard: () => void;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
  interfaceData: IEstablishmentInterfaceForm
}